import React from 'react';
import { Form, Label } from 'semantic-ui-react';

const prefix = 'channel.edit.coding_plan_v95.';

export default function CodingPlanPolicyV95({ config, onChange, t }) {
  return (
    <>
      <Form.Dropdown
        selection
        fluid
        label={t(prefix + 'strategy')}
        name='key_usage_strategy_v95'
        value={config.key_usage_strategy_v95 || 'round_robin'}
        options={[
          {
            key: 'round_robin',
            value: 'round_robin',
            text: t(prefix + 'round_robin'),
          },
          {
            key: 'coding_plan',
            value: 'coding_plan',
            text: t(prefix + 'coding_plan'),
          },
        ]}
        onChange={onChange}
      />
      {config.key_usage_strategy_v95 === 'coding_plan' && (
        <Form.Input
          type='number'
          min={1}
          max={168}
          step={1}
          label={t(prefix + 'fallback_hours')}
          name='coding_plan_cooldown_hours_v95'
          value={config.coding_plan_cooldown_hours_v95 ?? 5}
          onChange={onChange}
        />
      )}
    </>
  );
}

export function CodingPlanKeyV95({ row, onChange, t }) {
  const retryAt = Number(row.coding_plan_retry_at_v95 || 0);
  return (
    <div style={{ marginTop: 10 }}>
      <Form.Input
        fluid
        label={t(prefix + 'account_group')}
        placeholder={t(prefix + 'separate_account')}
        value={row.quota_group_v95 || ''}
        onChange={(_, { value }) => onChange({ quota_group_v95: value })}
      />
      <div
        style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 8 }}
      >
        {row.coding_plan_active_v95 && retryAt === 0 && (
          <Label color='green'>{t(prefix + 'active')}</Label>
        )}
        {retryAt > 0 && (
          <Label color={retryAt * 1000 > Date.now() ? 'yellow' : 'grey'}>
            {t(
              prefix +
                (retryAt * 1000 > Date.now() ? 'retry_at' : 'awaiting_probe')
            )}{' '}
            {new Date(retryAt * 1000).toLocaleString()}
          </Label>
        )}
      </div>
    </div>
  );
}
